import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductSectionItemComponent } from '../product-section-item/product-section-item.component';
import { ProductSectionItemExpandedProductInfoViewModel } from './product-section-item-expanded-product-info-view-model';

@Component({
  selector: 'app-product-section-item-expanded-product-info',
  templateUrl: './product-section-item-expanded-product-info.component.html',
  styleUrl: './product-section-item-expanded-product-info.component.scss',
  providers: [ProductSectionItemExpandedProductInfoViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProductSectionItemExpandedProductInfoComponent extends ProductSectionItemComponent {
  constructor(public viewModel: ProductSectionItemExpandedProductInfoViewModel) {
    super(viewModel);
  }
}
